import React, {Component} from 'react';
import isEqual from 'lodash/isEqual';
import {connect} from 'react-redux';
import {t} from 'l10n';

import LoginRedirect from 'components/LoginRedirect';
import ModalBecomeXXL from 'components/modals/ModalBecomeXXL';
import {followProfile, unfollowProfile} from 'reducers/member';

class FollowButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            ...this.getStateFromProps(props)
        };

        this.onClick = this.onClick.bind(this);
    }

    getStateFromProps(props) {
        let {followedByMe} = props;

        let onClick = () => {},
            label,
            className,
            loginRedirect = false,
            showModal = false;

        if (followedByMe) {
            label = t('Unfollow');
            onClick = () => {};
            className = 'button unfollow';
        } else {
            label = t('Follow');
            onClick = () => {};
            className = 'button follow';
        }

        return {
            onClick,
            label,
            className,
            loginRedirect,
            showModal
        }
    }

    onClick() {
        const {user, currentUser, followedByMe, followProfile, unfollowProfile} = this.props;

        if (!currentUser.isLoggedIn()) {
            this.setState({loginRedirect: true})
        } else if (!followedByMe) {
            followProfile(user.id)
        } else {
            unfollowProfile(user.id)
        }
    }

    componentDidUpdate(prevProps) {
        if (!isEqual(this.props, prevProps)) {
            this.setState({
                ...this.getStateFromProps(this.props)
            })
        }
    }

    componentBeforeUnmount() {
        this.setState({
            loginRedirect: false,
            showModal: false
        })
    }

    render() {
        const {returnPath} = this.props;

        const {label, className, showModal, loginRedirect} = this.state;

        if (loginRedirect) {
            return <LoginRedirect returnPath={returnPath}/>;
        }

        return (
            <a className={className} onClick={this.onClick}>
                {showModal && <ModalBecomeXXL show closeFn={() => this.setState({showModal: false})}/>}
                <div className="icon"/>
                <p>{label}</p>
            </a>
        )
    }
}

export default connect(
    null,
    {
        followProfile: followProfile,
        unfollowProfile: unfollowProfile
    }
)(FollowButton);


// WEBPACK FOOTER //
// ./src/components/profile/FollowButton.js